import axios from 'axios'

// 新闻列表接口
export const getNewsList = () => {
    return axios.get('/api/users/shops/news')
}